<div class="container-box" class="error-screen">
  <section class="shadowbox">
    <h1>Unauthorized !</h1>
    <p>Your are not an authorized user to access this site.</p>
  </section>
</div>
